import { useCallback, useRef } from "react";
import { useToast } from "@chakra-ui/react";

const TOAST_ID = "coming-soon-toast";

export default function useComingSoonToast() {
  const toast = useToast();
  const lastToastTime = useRef(0);

  const showComingSoon = useCallback(
    (name) => {
      const now = Date.now();
      if (now - lastToastTime.current < 2000) return;
      lastToastTime.current = now;

      if (toast.isActive(TOAST_ID)) return;

      toast({
        id: TOAST_ID,
        title: "Coming Soon",
        description: name
          ? `${name} is not available yet.`
          : "This game is not available yet.",
        status: "info",
        duration: 2000,
        isClosable: true,
        position: "top",
      });
    },
    [toast]
  );

  return showComingSoon;
}
